import { createAction } from "redux-actions";
import { GET_APPLICATION_MENU } from "../constants";
import {  feathersFindDataAll } from "../services";

export const getApplicationMenu= createAction(GET_APPLICATION_MENU, (data) => feathersFindDataAll('application-menu', data)())
